import * as React from "react"
import {Input, Label, Message, Popup} from "semantic-ui-react"
import ButtonLock from "../buttons/com_button-lock"
import {
    isError,
    getlangFromCache,
    isNotDroopyGuid,
    isDroopyGuid,
} from "../../../utils"
import {IFormFieldProps} from "."
import ButtonChange from "../buttons/com_button-change"
import {FieldType, permanentFormIds} from "../../../models"
import {MultilangString} from "../../../models/product/multilang-string"
import {
    checkInputValueIntegrity,
    PreviousValueMessage,
} from "./form-field-tools"

const InputField = (props: IFormFieldProps<string>) => {
    const {
        label = "",
        data,
        formId = "",
        disabled = false,
        onLockClick,
        onModifyClick,
        tabIndex,
        onclick,
        style,
        onfocus,
        numberProps,
        onChange,
        lang,
        onFieldLooseFocus,
        isNewProduct,
        placeholder,
        oldValue,
        currency,
        ...other
    } = props
    const {value, errorText, code, lock, isRequired, fieldType} = data
    const [initialized, setInitialized] = React.useState(false)
    const displayValue =
        currency &&
        typeof value !== "string" &&
        value !== null &&
        value !== undefined
            ? Number(value).toFixed(2)
            : value

    React.useEffect(() => {
        if (
            initialized ||
            (fieldType === FieldType.Standard &&
                data.value === data.regenerateInfos.defaultValue)
        ) {
            return
        }
        const checkedValue = checkInputValueIntegrity(data, other.type === "number", data.localized)
        if (JSON.stringify(data.value) !== JSON.stringify(checkedValue)) {
            onChange({
                code: data.code,
                fieldValue: checkedValue as string | MultilangString,
                lock: data.lock,
                fieldType: data.fieldType,
                lang: lang || getlangFromCache(),
                overrideDefaultValue: true,
            })
        }
        setInitialized(true)
    }, [data.code, data.value])

    const handleChange = (event: any) => {
        onChange({
            code: event.target.name,
            fieldValue: event.target.value,
            lock: data.lock,
            fieldType: data.fieldType,
            lang: lang || getlangFromCache(),
        })
    }

    const {
        min = 0,
        step = 0.01,
        max = 999999,
    } = numberProps || {
        min: 0,
        step: 0.01,
        max: 999999,
    }
    const onblur = () => onFieldLooseFocus(data)
    const formattedOldValue = isDroopyGuid(oldValue?.value + "")
        ? ""
        : oldValue?.value || "N/A"

    return (
        <div className="lock-div" style={style ? style.lockDiv || {} : {}}>
            {(value || formattedOldValue !== "N/A") && oldValue && `${formattedOldValue}` !== `${value}` ? (
                <PreviousValueMessage
                    label={oldValue.formattedDate}
                    content={formattedOldValue}
                />
            ) : (
                ""
            )}
            {isError(errorText) ? (
                <Message
                    className="error-field-message"
                    style={{
                        ...{width: 300},
                        ...(style ? style.textField || {} : {}),
                    }}
                    negative
                    header={errorText}
                />
            ) : (
                ""
            )}
            <Input
                {...other}
                value={displayValue}
                placeholder={placeholder}
                name={code}
                onChange={handleChange}
                style={style ? style.textField || {} : {}}
                className={
                    "corner text-field labeled " +
                    (errorText ? "error-field" : "") +
                    (data.isDeclinable ? "declinable " : "")
                }
                disabled={disabled}
            >
                {data.isDeclinable && (
                    <Popup
                        className="declinable-explanation"
                        content="Cette caractéristique peut être utilisée pour créer une tête & déclinée au sein de la famille sélectionnée"
                        trigger={
                            <Label color="blue" ribbon>
                                Declinable
                            </Label>
                        }
                    />
                )}
                <Label className="text-field-label dropdown-label" basic>
                    {typeof label === "string" ? label + (isRequired ? "*" : "") : label}
                </Label>
                <input
                    className={"tabbable"}
                    autoFocus={tabIndex === 500}
                    style={Object.assign({width: 146}, style ? style.text || {} : {})}
                    tabIndex={tabIndex}
                    autoComplete="off"
                    onClick={onclick}
                    min={min}
                    step={step}
                    max={max}
                    onFocus={onfocus}
                    onBlur={onblur}
                    placeholder={placeholder}
                />
                {formId === permanentFormIds.MULTI_MODIF && onModifyClick ? (
                    <ButtonChange
                        modified={data.modified}
                        onClick={onModifyClick}
                        code={code}
                        fieldType={fieldType}
                    />
                ) : (
                    <ButtonLock
                        hidden={!isNewProduct}
                        lockable={props.lockable}
                        onClick={onLockClick}
                        code={code}
                        lock={lock}
                        fieldType={fieldType}
                    />
                )}
            </Input>
        </div>
    )
}

export default InputField
